import stringify from "json-stringify-safe";
import { ConsoleLogger } from "amazon-chime-sdk-js";

export const toDebugString = (message: string, ...rest: unknown[]): string => {
  return `${message} ${rest.map(x => stringify(x)).join(" | ")}`;
};

export class JsonConsoleLogger extends ConsoleLogger {
  info(message: string, ...rest: any[]) {
    super.info(toDebugString(message, ...rest));
    console.log(...rest);
  }
  error(message: string, ...rest: any[]) {
    const w = (window as any)
    const toLog = toDebugString(message, ...rest)
    if(w.Rollbar) {
      w.Rollbar.error(toLog)
    }
    super.error(toLog);
  }
  debug(...rest: any) {
    const [message, ...others] = rest;
    super.debug(() => toDebugString(message, ...others));
  }
}
